import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useAppState from '../../AppStore';
import { useTools, ToolProps, DEFAULT_TOOL } from '../../tools/Tools';
import ToolbarItem from '../toolbar/ToolbarItem';
import { ToolNames } from '../../tools/ToolNames';

const ToolbarMobile = () => {
  const { t } = useTranslation('agisviewer');
  const isOpen = useAppState((state) => state.toolbar.isOpen);
  const toggleToolbar = useAppState((state) => state.toggleToolbar);
  const setActiveFlyin = useAppState((state) => state.setActiveFlyin);
  const enabledIdentify = useAppState((state) => state.enabledIdentify);

  const [activeTool, setActiveTool] = useAppState((state) => [
    state.activeTool,
    state.setActiveTool,
  ]);

  const handleOnClick = (name: ToolNames, { onClick, views }: ToolProps) => {
    const mainView = views?.find((v) => v.isMainView)?.key || '';

    if (name !== activeTool) {
      setActiveTool(name, mainView);
      setActiveFlyin(null);
    } else {
      setActiveTool(DEFAULT_TOOL);
    }

    onClick?.();
    toggleToolbar();
  };

  const extendedTools = Object.entries(useTools()).slice(2);

  const isActive = (name: string) => {
    return (
      (name === activeTool && name !== ToolNames.identify) ||
      (name === ToolNames.identify &&
        enabledIdentify &&
        ![ToolNames.draw, ToolNames.print].includes(activeTool))
    );
  };

  return (
    <menu className={classNames('toolbar', { 'toolbar--show': isOpen })}>
      <ul className="toolbar__items toolbar__items--expand">
        {extendedTools.map(([name, tool]) => (
          <ToolbarItem
            key={name}
            label={t(tool.label)}
            icon={tool.icon}
            isActive={isActive(name)}
            onClick={() => handleOnClick(name as ToolNames, tool)}
          />
        ))}
      </ul>
    </menu>
  );
};

export default ToolbarMobile;
